import { Show, ClerkProvider } from "@clerk/react";
import { Route, Routes, Navigate, useNavigate } from "react-router-dom";

import SignInPage from "@/pages/v2/sign-in-page";
import SignUpPage from "@/pages/v2/sign-up-page";
import SsoCallbackPage from "@/pages/sso-callback";
import TermsAndConditionsPage from "@/pages/legal/terms-and-conditions-page";

import RouteController from "./routes/route-controller";

import "./styles/nprogress.css";

function App() {
  const navigate = useNavigate();

  return (
    <ClerkProvider
      routerPush={(to) => navigate(to)}
      routerReplace={(to) => navigate(to, { replace: true })}
      signInUrl="/"
      signInFallbackRedirectUrl="/"
      signUpFallbackRedirectUrl="/"
    >
      <Show when="signed-out">
        <Routes>
          <Route path="/" element={<SignInPage />} />
          <Route path="/sign-up" element={<SignUpPage />} />
          <Route path="/sso-callback" element={<SsoCallbackPage />} />
          <Route path="/sign-in/continue" element={<SignInPage />} />

          <Route path="/legal/terms-and-conditions" element={<TermsAndConditionsPage />} />

          <Route path="/*" element={<Navigate to="/" replace />} />
        </Routes>
      </Show>

      <Show when="signed-in">
        <RouteController />
      </Show>
    </ClerkProvider>
  );
}

export default App;